module.exports = __webpack_public_path__ + "img/12.1313d0d8.png";